"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var imgSizes = ['thumb', 'small', 'medium', 'large', 'zoom'];
var imageUtil = {
    getVariants: function (images) {
        return images.map(function (image) {
            var expandedImage = __assign({}, image);
            var imgExt = image.url.substr(image.url.lastIndexOf('.'));
            imgSizes.forEach(function (size) {
                var newImage = "-".concat(size).concat(imgExt);
                expandedImage[size] = image.url.replace(imgExt, newImage);
            });
            return expandedImage;
        });
    },
};
exports.default = imageUtil;
//# sourceMappingURL=image.js.map